/**
* p05002固有メッセージ
*/

export const map = new Map([

/* Product information */
['product.name.05.002','キニッタ！グルメ 店舗用'], 
/* メールタイトル */
['product.name.05.002.title.mail','キニッタ！グルメ'],

/* メッセージ */
/* メッセージは05002001から連番で作成すること */
['msg.05002001','ランク名称は32文字以内で入力してください。'],
['msg.05002002','登録するポイントを選択して下さい。'],
['msg.05002003','登録するポイントが入力されてません。'],
['msg.05002004','チェックした項目のポイント数が入力されてません。'],
['msg.05002005','出力する履歴が存在しません。'],
['msg.05002006','会員番号が見つかりません。'],
['msg.05002007','アップロード出来る写真の上限({0}枚)に達しました。'],
['msg.05002008','イチオシには1枚しかアップロードできません。'],
['msg.05002009','写真は登録されていません。'],

/*
['msg.0501','お使いの端末ではスマートフォン版はご利用出来ません。ブラウザを開き https://www.https://www.esplanadeone.com/p05001/05/p/index.html よりPC版にアクセスして下さい。'],
['msg.0502','ご連絡用メールアドレスを入力して下さい。'],
['msg.0503','店舗が選択されてません。'],
['msg.0504','写真が選択されてません。'],
['msg.0505','写真は存在しません。'],
*/

/* ページタイトル */
['screen.s05002000.title','ログイン'],
['screen.s05002001.title','店舗一覧'],
['screen.s05002002.title','店舗管理'],
['screen.s05002003.title','店舗情報編集'],
['screen.s05002004.title','イベント登録、編集、削除'],
['screen.s05002005.title','店舗デイリーカレンダー'],
['screen.s05002006.title','会員検索'],
['screen.s05002007.title','会員情報'],
['screen.s05002008.title','会員ランク管理'],
['screen.s05002010.title','ポイント登録確認'],
['screen.s05002011.title','スタッフ管理'],
['screen.s05002012.title','スタッフ情報'],
['screen.s05002013.title','ポイント履歴'],
['screen.s05002014.title','店舗グループ一覧'],
['screen.s05002015.title','店舗グループ管理'],
['screen.s05002016.title','会員番号スキャン'],
['screen.s05002017.title','会計(会員以外)'],
['screen.s05002018.title','データ分析'],
['screen.s05002019.title','チャット'],

/* 画面ラベル */

/*キニッタ！会員ランク管理ページ用*/
['screen.s05002008.label.rankName','ランク名称'],
['screen.s05002008.label.desc1','三段階の会員ランク（ランク１＜ランク２＜ランク３）を設定できます。'],
['screen.s05002008.label.desc2','各ランク毎にランク名称を設定する事ができます。'],
['screen.s05002008.label.desc3','各ランク毎にランク名称、付与ポイント、ポイント有効期限を設定する事ができます。'],
['screen.s05002008.label.desc4','注意：この設定は同一店舗グループ内で共通ですので、この設定を変更すると同一店舗グループ内の他の店舗も設定も変更されます。'],

/*キニッタ！ポイント登録確認ページ用*/
['screen.s05002010.label.desc1','下に表示されているポイントを確認の上「確定」ボタンをタップしてください'],

/* キニッタ！ポイント履歴ページ用 */
['screen.s05002013.label.desc1','出力する履歴がありません'],

/* チャットページ用 */
['screen.s05002019.label.shop','お店'],
['screen.s05002019.label.noData','表示データはありません。表示日数を変更して下さい。'],
['screen.s05002019.label.deleted','に削除されました。'],
]);